var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuickTable',{ref:"table",attrs:{"request":"/api/services/app/SafetyWork/GetSafetyTechAsync","columns":_vm.initData.columns,"exports":{url: '/api/File/ExportSafetyTechAsync', fileName: '安全技术交底记录'}}})}
var staticRenderFns = []

export { render, staticRenderFns }